import { Link } from "react-router-dom";
import { ArrowUpRight, CalendarCheck } from "lucide-react";
import { Reveal } from "@/components/motion";
import { LINKS } from "@/data/content";

const CTASection = ({
  title = "Ready to begin?",
  accent = "Trust yourself.",
  body = "Book a time and let's have a chat about where you're at and what support makes sense for you.",
}) => (
  <section data-testid="cta-section" className="bg-ink text-white grain">
    <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-24 md:py-36">
      <Reveal>
        <p className="label-text text-ocean">The next step</p>
        <h2 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance">
          {title}
          <br />
          <span className="italic font-light text-white/70">{accent}</span>
        </h2>
        <p className="mt-6 max-w-xl text-base md:text-lg text-white/60">{body}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href={LINKS.calendly}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-book-call-button"
            className="inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-ink transition-colors duration-300 hover:bg-ocean hover:text-white"
          >
            <CalendarCheck size={16} strokeWidth={1.5} />
            Book a free call
          </a>
          <Link
            to="/contact"
            data-testid="cta-enquiry-button"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:border-ocean hover:text-ocean"
          >
            Send an enquiry
            <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
